import React, { useState } from 'react';
import { BsPencilSquare, BsClipboardData, BsX, BsArrowUp, BsArrowDown, BsCheckCircle } from 'react-icons/bs';
import styles from '../../HedefFormu.module.css';

const ProjelerCard = ({ data, onEdit }) => {
  const [showEditModal, setShowEditModal] = useState(false);

  const TARGET = {
    horizonEuropeYurutucu: 1,
    horizonEuropeArastirmaci: 2,
    horizonOrtaklikYurutucu: 1,
    horizonOrtaklikArastirmaci: 2,
    tubitakIkiliIsbirligiYurutucu: 1,
    tubitakIkiliIsbirligiArastirmaci: 2,
    tubitak1001Yurutucu: 2,
    tubitak1001Arastirmaci: 3,
    tubitak1002Yurutucu: 1,
    tubitak1002Arastirmaci: 2,
    tubitak1003Yurutucu: 1,
    tubitak1003Arastirmaci: 2,
    tubitak1004Yurutucu: 1,
    tubitak1004Arastirmaci: 2,
    tubitak1005Yurutucu: 1,
    tubitak1005Arastirmaci: 2,
    tubitak1505Yurutucu: 1,
    tubitak1505Arastirmaci: 2,
    tubitak2209Yurutucu: 1,
    tubitak2209Arastirmaci: 2,
    tubitak3005Yurutucu: 1,
    tubitak3005Arastirmaci: 2,
    tubitak3501Yurutucu: 1,
    tubitak3501Arastirmaci: 2,
    erasmusYurutucu: 1,
    erasmusArastirmaci: 2,
    digerAbYurutucu: 1,
    digerAbArastirmaci: 2,
    tusebYurutucu: 1,
    tusebArastirmaci: 2,
    kosgebYurutucu: 1,
    kosgebArastirmaci: 2,
    istkaYurutucu: 1,
    istkaArastirmaci: 2,
    bapYurutucu: 2,
    bapArastirmaci: 3,
    adepYurutucu: 1,
    adepArastirmaci: 2,
    univSanIsbirligiYurutucu: 1,
    univSanIsbirligiArastirmaci: 2
  };

  const completionStatus = {
    horizonEuropeYurutucu: data.horizonEuropeYurutucu >= TARGET.horizonEuropeYurutucu,
    horizonEuropeArastirmaci: data.horizonEuropeArastirmaci >= TARGET.horizonEuropeArastirmaci,
    horizonOrtaklikYurutucu: data.horizonOrtaklikYurutucu >= TARGET.horizonOrtaklikYurutucu,
    horizonOrtaklikArastirmaci: data.horizonOrtaklikArastirmaci >= TARGET.horizonOrtaklikArastirmaci,
    tubitakIkiliIsbirligiYurutucu: data.tubitakIkiliIsbirligiYurutucu >= TARGET.tubitakIkiliIsbirligiYurutucu,
    tubitakIkiliIsbirligiArastirmaci: data.tubitakIkiliIsbirligiArastirmaci >= TARGET.tubitakIkiliIsbirligiArastirmaci,
    tubitak1001Yurutucu: data.tubitak1001Yurutucu >= TARGET.tubitak1001Yurutucu,
    tubitak1001Arastirmaci: data.tubitak1001Arastirmaci >= TARGET.tubitak1001Arastirmaci,
    tubitak1002Yurutucu: data.tubitak1002Yurutucu >= TARGET.tubitak1002Yurutucu,
    tubitak1002Arastirmaci: data.tubitak1002Arastirmaci >= TARGET.tubitak1002Arastirmaci,
    tubitak1003Yurutucu: data.tubitak1003Yurutucu >= TARGET.tubitak1003Yurutucu,
    tubitak1003Arastirmaci: data.tubitak1003Arastirmaci >= TARGET.tubitak1003Arastirmaci,
    tubitak1004Yurutucu: data.tubitak1004Yurutucu >= TARGET.tubitak1004Yurutucu,
    tubitak1004Arastirmaci: data.tubitak1004Arastirmaci >= TARGET.tubitak1004Arastirmaci,
    tubitak1005Yurutucu: data.tubitak1005Yurutucu >= TARGET.tubitak1005Yurutucu,
    tubitak1005Arastirmaci: data.tubitak1005Arastirmaci >= TARGET.tubitak1005Arastirmaci,
    tubitak1505Yurutucu: data.tubitak1505Yurutucu >= TARGET.tubitak1505Yurutucu,
    tubitak1505Arastirmaci: data.tubitak1505Arastirmaci >= TARGET.tubitak1505Arastirmaci,
    tubitak2209Yurutucu: data.tubitak2209Yurutucu >= TARGET.tubitak2209Yurutucu,
    tubitak2209Arastirmaci: data.tubitak2209Arastirmaci >= TARGET.tubitak2209Arastirmaci,
    tubitak3005Yurutucu: data.tubitak3005Yurutucu >= TARGET.tubitak3005Yurutucu,
    tubitak3005Arastirmaci: data.tubitak3005Arastirmaci >= TARGET.tubitak3005Arastirmaci,
    tubitak3501Yurutucu: data.tubitak3501Yurutucu >= TARGET.tubitak3501Yurutucu,
    tubitak3501Arastirmaci: data.tubitak3501Arastirmaci >= TARGET.tubitak3501Arastirmaci,
    erasmusYurutucu: data.erasmusYurutucu >= TARGET.erasmusYurutucu,
    erasmusArastirmaci: data.erasmusArastirmaci >= TARGET.erasmusArastirmaci,
    digerAbYurutucu: data.digerAbYurutucu >= TARGET.digerAbYurutucu,
    digerAbArastirmaci: data.digerAbArastirmaci >= TARGET.digerAbArastirmaci,
    tusebYurutucu: data.tusebYurutucu >= TARGET.tusebYurutucu,
    tusebArastirmaci: data.tusebArastirmaci >= TARGET.tusebArastirmaci,
    kosgebYurutucu: data.kosgebYurutucu >= TARGET.kosgebYurutucu,
    kosgebArastirmaci: data.kosgebArastirmaci >= TARGET.kosgebArastirmaci,
    istkaYurutucu: data.istkaYurutucu >= TARGET.istkaYurutucu,
    istkaArastirmaci: data.istkaArastirmaci >= TARGET.istkaArastirmaci,
    bapYurutucu: data.bapYurutucu >= TARGET.bapYurutucu,
    bapArastirmaci: data.bapArastirmaci >= TARGET.bapArastirmaci,
    adepYurutucu: data.adepYurutucu >= TARGET.adepYurutucu,
    adepArastirmaci: data.adepArastirmaci >= TARGET.adepArastirmaci,
    univSanIsbirligiYurutucu: data.univSanIsbirligiYurutucu >= TARGET.univSanIsbirligiYurutucu,
    univSanIsbirligiArastirmaci: data.univSanIsbirligiArastirmaci >= TARGET.univSanIsbirligiArastirmaci
  };

  const safeSum = (a, b) => {
    const numA = Number(a) || 0;
    const numB = Number(b) || 0;
    return numA + numB;
  };

  const calculateTotal = (yurutucu, arastirmaci) => {
    const total = safeSum(yurutucu, arastirmaci);
    return total;
  };

  const totalHorizon = calculateTotal(data.horizonEuropeYurutucu, data.horizonEuropeArastirmaci);
  const targetHorizon = calculateTotal(TARGET.horizonEuropeYurutucu, TARGET.horizonEuropeArastirmaci);

  const totalHorizonOrtaklik = calculateTotal(data.horizonOrtaklikYurutucu, data.horizonOrtaklikArastirmaci);
  const targetHorizonOrtaklik = calculateTotal(TARGET.horizonOrtaklikYurutucu, TARGET.horizonOrtaklikArastirmaci);

  const totalTubitakIkiliIsbirligi = calculateTotal(data.tubitakIkiliIsbirligiYurutucu, data.tubitakIkiliIsbirligiArastirmaci);
  const targetTubitakIkiliIsbirligi = calculateTotal(TARGET.tubitakIkiliIsbirligiYurutucu, TARGET.tubitakIkiliIsbirligiArastirmaci);

  const totalTubitak = 
    calculateTotal(data.tubitak1001Yurutucu, data.tubitak1001Arastirmaci) +
    calculateTotal(data.tubitak1002Yurutucu, data.tubitak1002Arastirmaci) +
    calculateTotal(data.tubitak1003Yurutucu, data.tubitak1003Arastirmaci) +
    calculateTotal(data.tubitak1004Yurutucu, data.tubitak1004Arastirmaci) +
    calculateTotal(data.tubitak1005Yurutucu, data.tubitak1005Arastirmaci) +
    calculateTotal(data.tubitak1505Yurutucu, data.tubitak1505Arastirmaci) +
    calculateTotal(data.tubitak2209Yurutucu, data.tubitak2209Arastirmaci) +
    calculateTotal(data.tubitak3005Yurutucu, data.tubitak3005Arastirmaci) +
    calculateTotal(data.tubitak3501Yurutucu, data.tubitak3501Arastirmaci);
    
  const targetTubitak = 
    calculateTotal(TARGET.tubitak1001Yurutucu, TARGET.tubitak1001Arastirmaci) +
    calculateTotal(TARGET.tubitak1002Yurutucu, TARGET.tubitak1002Arastirmaci) +
    calculateTotal(TARGET.tubitak1003Yurutucu, TARGET.tubitak1003Arastirmaci) +
    calculateTotal(TARGET.tubitak1004Yurutucu, TARGET.tubitak1004Arastirmaci) +
    calculateTotal(TARGET.tubitak1005Yurutucu, TARGET.tubitak1005Arastirmaci) +
    calculateTotal(TARGET.tubitak1505Yurutucu, TARGET.tubitak1505Arastirmaci) +
    calculateTotal(TARGET.tubitak2209Yurutucu, TARGET.tubitak2209Arastirmaci) +
    calculateTotal(TARGET.tubitak3005Yurutucu, TARGET.tubitak3005Arastirmaci) +
    calculateTotal(TARGET.tubitak3501Yurutucu, TARGET.tubitak3501Arastirmaci);

  const totalBap = calculateTotal(data.bapYurutucu, data.bapArastirmaci);
  const targetBap = calculateTotal(TARGET.bapYurutucu, TARGET.bapArastirmaci);

  const totalErasmus = calculateTotal(data.erasmusYurutucu, data.erasmusArastirmaci);
  const targetErasmus = calculateTotal(TARGET.erasmusYurutucu, TARGET.erasmusArastirmaci);

  const totalDigerAb = calculateTotal(data.digerAbYurutucu, data.digerAbArastirmaci);
  const targetDigerAb = calculateTotal(TARGET.digerAbYurutucu, TARGET.digerAbArastirmaci);

  const totalTuseb = calculateTotal(data.tusebYurutucu, data.tusebArastirmaci);
  const targetTuseb = calculateTotal(TARGET.tusebYurutucu, TARGET.tusebArastirmaci);

  const totalAdep = calculateTotal(data.adepYurutucu, data.adepArastirmaci);
  const targetAdep = calculateTotal(TARGET.adepYurutucu, TARGET.adepArastirmaci);

  const totalUnivSanIsbirligi = calculateTotal(data.univSanIsbirligiYurutucu, data.univSanIsbirligiArastirmaci);
  const targetUnivSanIsbirligi = calculateTotal(TARGET.univSanIsbirligiYurutucu, TARGET.univSanIsbirligiArastirmaci);

  const totalKosgeb = calculateTotal(data.kosgebYurutucu, data.kosgebArastirmaci);
  const targetKosgeb = calculateTotal(TARGET.kosgebYurutucu, TARGET.kosgebArastirmaci);

  const totalIstka = calculateTotal(data.istkaYurutucu, data.istkaArastirmaci);
  const targetIstka = calculateTotal(TARGET.istkaYurutucu, TARGET.istkaArastirmaci);

  const totalProjects = [
    totalHorizon, totalHorizonOrtaklik, totalTubitakIkiliIsbirligi, totalTubitak, totalBap, totalErasmus, totalDigerAb,
    totalTuseb, totalAdep, totalUnivSanIsbirligi, totalKosgeb, totalIstka
  ].reduce((sum, current) => safeSum(sum, current), 0);

  const targetTotal = [
    targetHorizon, targetHorizonOrtaklik, targetTubitakIkiliIsbirligi, targetTubitak, targetBap, targetErasmus, targetDigerAb,
    targetTuseb, targetAdep, targetUnivSanIsbirligi, targetKosgeb, targetIstka
  ].reduce((sum, current) => safeSum(sum, current), 0);

  const handleEdit = () => {
    setShowEditModal(true);
  };

  return (
    <div className={styles.card} data-type="projeler">
      <div className={styles.cardHeader}>
        <h3 className={styles.cardTitle}>
          <BsClipboardData className={styles.cardIcon} />
          Projeler
        </h3>
        <div className={styles.cardActions}>
          <button 
            className={styles.actionButton}
            onClick={handleEdit}
            aria-label="Projeleri düzenle"
          >
            <BsPencilSquare />
          </button>
        </div>
      </div>

      <div>
        <div className={styles.formSection}>
          <h4 className={styles.formTitle}>Horizon Europe Projeleri</h4>
          <div className={styles.statRow}>
            <span className={styles.statLabel}>
              Yürütücü
              {completionStatus.horizonEuropeYurutucu && <BsCheckCircle className={styles.targetComplete} />}
              <span className={styles.targetInfo}>(Hedef: {TARGET.horizonEuropeYurutucu})</span>
            </span>
            <div className={styles.statValue}>{data.horizonEuropeYurutucu}</div>
          </div>
          <div className={styles.statRow}>
            <span className={styles.statLabel}>
              Araştırmacı
              {completionStatus.horizonEuropeArastirmaci && <BsCheckCircle className={styles.targetComplete} />}
              <span className={styles.targetInfo}>(Hedef: {TARGET.horizonEuropeArastirmaci})</span>
            </span>
            <div className={styles.statValue}>{data.horizonEuropeArastirmaci}</div>
          </div>
          <div className={styles.targetStatus}>
            <div className={styles.targetItem}>
              <span>Toplam:</span>
              <span className={totalHorizon >= targetHorizon ? styles.targetComplete : styles.targetIncomplete}>
                {totalHorizon} / {targetHorizon}
              </span>
            </div>
          </div>
        </div>

        <div className={styles.formSection}>
          <h4 className={styles.formTitle}>HORIZON EUROPE ORTAKLIK PROJELERİ</h4>
          <p className={styles.detailsLabel}>ERA PerMed, PRIMA, IHI vb.</p>
          <div className={styles.statRow}>
            <span className={styles.statLabel}>
              Yürütücü
              {completionStatus.horizonOrtaklikYurutucu && <BsCheckCircle className={styles.targetComplete} />}
              <span className={styles.targetInfo}>(Hedef: {TARGET.horizonOrtaklikYurutucu})</span>
            </span>
            <div className={styles.statValue}>{data.horizonOrtaklikYurutucu}</div>
          </div>
          <div className={styles.statRow}>
            <span className={styles.statLabel}>
              Araştırmacı
              {completionStatus.horizonOrtaklikArastirmaci && <BsCheckCircle className={styles.targetComplete} />}
              <span className={styles.targetInfo}>(Hedef: {TARGET.horizonOrtaklikArastirmaci})</span>
            </span>
            <div className={styles.statValue}>{data.horizonOrtaklikArastirmaci}</div>
          </div>
          <div className={styles.targetStatus}>
            <div className={styles.targetItem}>
              <span>Toplam:</span>
              <span className={totalHorizonOrtaklik >= targetHorizonOrtaklik ? styles.targetComplete : styles.targetIncomplete}>
                {totalHorizonOrtaklik} / {targetHorizonOrtaklik}
              </span>
            </div>
          </div>
        </div>

        <div className={styles.formSection}>
          <h4 className={styles.formTitle}>TÜBİTAK İKİLİ İŞBİRLİĞİ (1071)</h4>
          <div className={styles.statRow}>
            <span className={styles.statLabel}>
              Yürütücü
              {completionStatus.tubitakIkiliIsbirligiYurutucu && <BsCheckCircle className={styles.targetComplete} />}
              <span className={styles.targetInfo}>(Hedef: {TARGET.tubitakIkiliIsbirligiYurutucu})</span>
            </span>
            <div className={styles.statValue}>{data.tubitakIkiliIsbirligiYurutucu}</div>
          </div>
          <div className={styles.statRow}>
            <span className={styles.statLabel}>
              Araştırmacı
              {completionStatus.tubitakIkiliIsbirligiArastirmaci && <BsCheckCircle className={styles.targetComplete} />}
              <span className={styles.targetInfo}>(Hedef: {TARGET.tubitakIkiliIsbirligiArastirmaci})</span>
            </span>
            <div className={styles.statValue}>{data.tubitakIkiliIsbirligiArastirmaci}</div>
          </div>
          <div className={styles.targetStatus}>
            <div className={styles.targetItem}>
              <span>Toplam:</span>
              <span className={totalTubitakIkiliIsbirligi >= targetTubitakIkiliIsbirligi ? styles.targetComplete : styles.targetIncomplete}>
                {totalTubitakIkiliIsbirligi} / {targetTubitakIkiliIsbirligi}
              </span>
            </div>
          </div>
        </div>

        <div className={styles.formSection}>
          <h4 className={styles.formTitle}>TÜBİTAK 1001 Projeleri</h4>
          <div className={styles.statRow}>
            <span className={styles.statLabel}>
              Yürütücü
              {completionStatus.tubitak1001Yurutucu && <BsCheckCircle className={styles.targetComplete} />}
              <span className={styles.targetInfo}>(Hedef: {TARGET.tubitak1001Yurutucu})</span>
            </span>
            <div className={styles.statValue}>{data.tubitak1001Yurutucu}</div>
          </div>
          <div className={styles.statRow}>
            <span className={styles.statLabel}>
              Araştırmacı
              {completionStatus.tubitak1001Arastirmaci && <BsCheckCircle className={styles.targetComplete} />}
              <span className={styles.targetInfo}>(Hedef: {TARGET.tubitak1001Arastirmaci})</span>
            </span>
            <div className={styles.statValue}>{data.tubitak1001Arastirmaci}</div>
          </div>
          <div className={styles.targetStatus}>
            <div className={styles.targetItem}>
              <span>Toplam:</span>
              <span className={data.tubitak1001Yurutucu + data.tubitak1001Arastirmaci >= TARGET.tubitak1001Yurutucu + TARGET.tubitak1001Arastirmaci ? styles.targetComplete : styles.targetIncomplete}>
                {data.tubitak1001Yurutucu + data.tubitak1001Arastirmaci} / {TARGET.tubitak1001Yurutucu + TARGET.tubitak1001Arastirmaci}
              </span>
            </div>
          </div>
        </div>

        <div className={styles.formSection}>
          <h4 className={styles.formTitle}>TÜBİTAK 1002 Projeleri</h4>
          <div className={styles.statRow}>
            <span className={styles.statLabel}>
              Yürütücü
              {completionStatus.tubitak1002Yurutucu && <BsCheckCircle className={styles.targetComplete} />}
              <span className={styles.targetInfo}>(Hedef: {TARGET.tubitak1002Yurutucu})</span>
            </span>
            <div className={styles.statValue}>{data.tubitak1002Yurutucu}</div>
          </div>
          <div className={styles.statRow}>
            <span className={styles.statLabel}>
              Araştırmacı
              {completionStatus.tubitak1002Arastirmaci && <BsCheckCircle className={styles.targetComplete} />}
              <span className={styles.targetInfo}>(Hedef: {TARGET.tubitak1002Arastirmaci})</span>
            </span>
            <div className={styles.statValue}>{data.tubitak1002Arastirmaci}</div>
          </div>
          <div className={styles.targetStatus}>
            <div className={styles.targetItem}>
              <span>Toplam:</span>
              <span className={calculateTotal(data.tubitak1002Yurutucu, data.tubitak1002Arastirmaci) >= calculateTotal(TARGET.tubitak1002Yurutucu, TARGET.tubitak1002Arastirmaci) ? styles.targetComplete : styles.targetIncomplete}>
                {calculateTotal(data.tubitak1002Yurutucu, data.tubitak1002Arastirmaci)} / {calculateTotal(TARGET.tubitak1002Yurutucu, TARGET.tubitak1002Arastirmaci)}
              </span>
            </div>
          </div>
        </div>

        <div className={styles.formSection}>
          <h4 className={styles.formTitle}>TÜBİTAK 1003 Projeleri</h4>
          <div className={styles.statRow}>
            <span className={styles.statLabel}>
              Yürütücü
              {completionStatus.tubitak1003Yurutucu && <BsCheckCircle className={styles.targetComplete} />}
              <span className={styles.targetInfo}>(Hedef: {TARGET.tubitak1003Yurutucu})</span>
            </span>
            <div className={styles.statValue}>{data.tubitak1003Yurutucu}</div>
          </div>
          <div className={styles.statRow}>
            <span className={styles.statLabel}>
              Araştırmacı
              {completionStatus.tubitak1003Arastirmaci && <BsCheckCircle className={styles.targetComplete} />}
              <span className={styles.targetInfo}>(Hedef: {TARGET.tubitak1003Arastirmaci})</span>
            </span>
            <div className={styles.statValue}>{data.tubitak1003Arastirmaci}</div>
          </div>
          <div className={styles.targetStatus}>
            <div className={styles.targetItem}>
              <span>Toplam:</span>
              <span className={calculateTotal(data.tubitak1003Yurutucu, data.tubitak1003Arastirmaci) >= calculateTotal(TARGET.tubitak1003Yurutucu, TARGET.tubitak1003Arastirmaci) ? styles.targetComplete : styles.targetIncomplete}>
                {calculateTotal(data.tubitak1003Yurutucu, data.tubitak1003Arastirmaci)} / {calculateTotal(TARGET.tubitak1003Yurutucu, TARGET.tubitak1003Arastirmaci)}
              </span>
            </div>
          </div>
        </div>

        <div className={styles.formSection}>
          <h4 className={styles.formTitle}>TÜBİTAK 1004 Projeleri</h4>
          <div className={styles.statRow}>
            <span className={styles.statLabel}>
              Yürütücü
              {completionStatus.tubitak1004Yurutucu && <BsCheckCircle className={styles.targetComplete} />}
              <span className={styles.targetInfo}>(Hedef: {TARGET.tubitak1004Yurutucu})</span>
            </span>
            <div className={styles.statValue}>{data.tubitak1004Yurutucu}</div>
          </div>
          <div className={styles.statRow}>
            <span className={styles.statLabel}>
              Araştırmacı
              {completionStatus.tubitak1004Arastirmaci && <BsCheckCircle className={styles.targetComplete} />}
              <span className={styles.targetInfo}>(Hedef: {TARGET.tubitak1004Arastirmaci})</span>
            </span>
            <div className={styles.statValue}>{data.tubitak1004Arastirmaci}</div>
          </div>
          <div className={styles.targetStatus}>
            <div className={styles.targetItem}>
              <span>Toplam:</span>
              <span className={data.tubitak1004Yurutucu + data.tubitak1004Arastirmaci >= TARGET.tubitak1004Yurutucu + TARGET.tubitak1004Arastirmaci ? styles.targetComplete : styles.targetIncomplete}>
                {data.tubitak1004Yurutucu + data.tubitak1004Arastirmaci} / {TARGET.tubitak1004Yurutucu + TARGET.tubitak1004Arastirmaci}
              </span>
            </div>
          </div>
        </div>

        <div className={styles.formSection}>
          <h4 className={styles.formTitle}>TÜBİTAK 1005 Projeleri</h4>
          <div className={styles.statRow}>
            <span className={styles.statLabel}>
              Yürütücü
              {completionStatus.tubitak1005Yurutucu && <BsCheckCircle className={styles.targetComplete} />}
              <span className={styles.targetInfo}>(Hedef: {TARGET.tubitak1005Yurutucu})</span>
            </span>
            <div className={styles.statValue}>{data.tubitak1005Yurutucu}</div>
          </div>
          <div className={styles.statRow}>
            <span className={styles.statLabel}>
              Araştırmacı
              {completionStatus.tubitak1005Arastirmaci && <BsCheckCircle className={styles.targetComplete} />}
              <span className={styles.targetInfo}>(Hedef: {TARGET.tubitak1005Arastirmaci})</span>
            </span>
            <div className={styles.statValue}>{data.tubitak1005Arastirmaci}</div>
          </div>
          <div className={styles.targetStatus}>
            <div className={styles.targetItem}>
              <span>Toplam:</span>
              <span className={data.tubitak1005Yurutucu + data.tubitak1005Arastirmaci >= TARGET.tubitak1005Yurutucu + TARGET.tubitak1005Arastirmaci ? styles.targetComplete : styles.targetIncomplete}>
                {data.tubitak1005Yurutucu + data.tubitak1005Arastirmaci} / {TARGET.tubitak1005Yurutucu + TARGET.tubitak1005Arastirmaci}
              </span>
            </div>
          </div>
        </div>

        <div className={styles.formSection}>
          <h4 className={styles.formTitle}>TÜBİTAK 1505 Projeleri</h4>
          <div className={styles.statRow}>
            <span className={styles.statLabel}>
              Yürütücü
              {completionStatus.tubitak1505Yurutucu && <BsCheckCircle className={styles.targetComplete} />}
              <span className={styles.targetInfo}>(Hedef: {TARGET.tubitak1505Yurutucu})</span>
            </span>
            <div className={styles.statValue}>{data.tubitak1505Yurutucu}</div>
          </div>
          <div className={styles.statRow}>
            <span className={styles.statLabel}>
              Araştırmacı
              {completionStatus.tubitak1505Arastirmaci && <BsCheckCircle className={styles.targetComplete} />}
              <span className={styles.targetInfo}>(Hedef: {TARGET.tubitak1505Arastirmaci})</span>
            </span>
            <div className={styles.statValue}>{data.tubitak1505Arastirmaci}</div>
          </div>
          <div className={styles.targetStatus}>
            <div className={styles.targetItem}>
              <span>Toplam:</span>
              <span className={data.tubitak1505Yurutucu + data.tubitak1505Arastirmaci >= TARGET.tubitak1505Yurutucu + TARGET.tubitak1505Arastirmaci ? styles.targetComplete : styles.targetIncomplete}>
                {data.tubitak1505Yurutucu + data.tubitak1505Arastirmaci} / {TARGET.tubitak1505Yurutucu + TARGET.tubitak1505Arastirmaci}
              </span>
            </div>
          </div>
        </div>

        <div className={styles.formSection}>
          <h4 className={styles.formTitle}>TÜBİTAK 2209 Projeleri</h4>
          <div className={styles.statRow}>
            <span className={styles.statLabel}>
              Yürütücü
              {completionStatus.tubitak2209Yurutucu && <BsCheckCircle className={styles.targetComplete} />}
              <span className={styles.targetInfo}>(Hedef: {TARGET.tubitak2209Yurutucu})</span>
            </span>
            <div className={styles.statValue}>{data.tubitak2209Yurutucu}</div>
          </div>
          <div className={styles.statRow}>
            <span className={styles.statLabel}>
              Araştırmacı
              {completionStatus.tubitak2209Arastirmaci && <BsCheckCircle className={styles.targetComplete} />}
              <span className={styles.targetInfo}>(Hedef: {TARGET.tubitak2209Arastirmaci})</span>
            </span>
            <div className={styles.statValue}>{data.tubitak2209Arastirmaci}</div>
          </div>
          <div className={styles.targetStatus}>
            <div className={styles.targetItem}>
              <span>Toplam:</span>
              <span className={data.tubitak2209Yurutucu + data.tubitak2209Arastirmaci >= TARGET.tubitak2209Yurutucu + TARGET.tubitak2209Arastirmaci ? styles.targetComplete : styles.targetIncomplete}>
                {data.tubitak2209Yurutucu + data.tubitak2209Arastirmaci} / {TARGET.tubitak2209Yurutucu + TARGET.tubitak2209Arastirmaci}
              </span>
            </div>
          </div>
        </div>

        <div className={styles.formSection}>
          <h4 className={styles.formTitle}>TÜBİTAK 3005 Projeleri</h4>
          <div className={styles.statRow}>
            <span className={styles.statLabel}>
              Yürütücü
              {completionStatus.tubitak3005Yurutucu && <BsCheckCircle className={styles.targetComplete} />}
              <span className={styles.targetInfo}>(Hedef: {TARGET.tubitak3005Yurutucu})</span>
            </span>
            <div className={styles.statValue}>{data.tubitak3005Yurutucu}</div>
          </div>
          <div className={styles.statRow}>
            <span className={styles.statLabel}>
              Araştırmacı
              {completionStatus.tubitak3005Arastirmaci && <BsCheckCircle className={styles.targetComplete} />}
              <span className={styles.targetInfo}>(Hedef: {TARGET.tubitak3005Arastirmaci})</span>
            </span>
            <div className={styles.statValue}>{data.tubitak3005Arastirmaci}</div>
          </div>
          <div className={styles.targetStatus}>
            <div className={styles.targetItem}>
              <span>Toplam:</span>
              <span className={data.tubitak3005Yurutucu + data.tubitak3005Arastirmaci >= TARGET.tubitak3005Yurutucu + TARGET.tubitak3005Arastirmaci ? styles.targetComplete : styles.targetIncomplete}>
                {data.tubitak3005Yurutucu + data.tubitak3005Arastirmaci} / {TARGET.tubitak3005Yurutucu + TARGET.tubitak3005Arastirmaci}
              </span>
            </div>
          </div>
        </div>

        <div className={styles.formSection}>
          <h4 className={styles.formTitle}>TÜBİTAK 3501 Projeleri</h4>
          <div className={styles.statRow}>
            <span className={styles.statLabel}>
              Yürütücü
              {completionStatus.tubitak3501Yurutucu && <BsCheckCircle className={styles.targetComplete} />}
              <span className={styles.targetInfo}>(Hedef: {TARGET.tubitak3501Yurutucu})</span>
            </span>
            <div className={styles.statValue}>{data.tubitak3501Yurutucu}</div>
          </div>
          <div className={styles.statRow}>
            <span className={styles.statLabel}>
              Araştırmacı
              {completionStatus.tubitak3501Arastirmaci && <BsCheckCircle className={styles.targetComplete} />}
              <span className={styles.targetInfo}>(Hedef: {TARGET.tubitak3501Arastirmaci})</span>
            </span>
            <div className={styles.statValue}>{data.tubitak3501Arastirmaci}</div>
          </div>
          <div className={styles.targetStatus}>
            <div className={styles.targetItem}>
              <span>Toplam:</span>
              <span className={data.tubitak3501Yurutucu + data.tubitak3501Arastirmaci >= TARGET.tubitak3501Yurutucu + TARGET.tubitak3501Arastirmaci ? styles.targetComplete : styles.targetIncomplete}>
                {data.tubitak3501Yurutucu + data.tubitak3501Arastirmaci} / {TARGET.tubitak3501Yurutucu + TARGET.tubitak3501Arastirmaci}
              </span>
            </div>
          </div>
        </div>

        <div className={styles.formSection}>
          <h4 className={styles.formTitle}>ERASMUS+ Projeleri</h4>
          <div className={styles.statRow}>
            <span className={styles.statLabel}>
              Yürütücü
              {completionStatus.erasmusYurutucu && <BsCheckCircle className={styles.targetComplete} />}
              <span className={styles.targetInfo}>(Hedef: {TARGET.erasmusYurutucu})</span>
            </span>
            <div className={styles.statValue}>{data.erasmusYurutucu}</div>
          </div>
          <div className={styles.statRow}>
            <span className={styles.statLabel}>
              Araştırmacı
              {completionStatus.erasmusArastirmaci && <BsCheckCircle className={styles.targetComplete} />}
              <span className={styles.targetInfo}>(Hedef: {TARGET.erasmusArastirmaci})</span>
            </span>
            <div className={styles.statValue}>{data.erasmusArastirmaci}</div>
          </div>
        </div>

        <div className={styles.formSection}>
          <h4 className={styles.formTitle}>Diğer AB Projeleri</h4>
          <p className={styles.detailsLabel}>
            UNICEF, UNDP, NVIDIA vb.
          </p>
          <div className={styles.statRow}>
            <span className={styles.statLabel}>
              Yürütücü
              {completionStatus.digerAbYurutucu && <BsCheckCircle className={styles.targetComplete} />}
              <span className={styles.targetInfo}>(Hedef: {TARGET.digerAbYurutucu})</span>
            </span>
            <div className={styles.statValue}>{data.digerAbYurutucu}</div>
          </div>
          <div className={styles.statRow}>
            <span className={styles.statLabel}>
              Araştırmacı
              {completionStatus.digerAbArastirmaci && <BsCheckCircle className={styles.targetComplete} />}
              <span className={styles.targetInfo}>(Hedef: {TARGET.digerAbArastirmaci})</span>
            </span>
            <div className={styles.statValue}>{data.digerAbArastirmaci}</div>
          </div>
        </div>

        <div className={styles.formSection}>
          <h4 className={styles.formTitle}>TÜSEB Projeleri</h4>
          <div className={styles.statRow}>
            <span className={styles.statLabel}>
              Yürütücü
              {completionStatus.tusebYurutucu && <BsCheckCircle className={styles.targetComplete} />}
              <span className={styles.targetInfo}>(Hedef: {TARGET.tusebYurutucu})</span>
            </span>
            <div className={styles.statValue}>{data.tusebYurutucu}</div>
          </div>
          <div className={styles.statRow}>
            <span className={styles.statLabel}>
              Araştırmacı
              {completionStatus.tusebArastirmaci && <BsCheckCircle className={styles.targetComplete} />}
              <span className={styles.targetInfo}>(Hedef: {TARGET.tusebArastirmaci})</span>
            </span>
            <div className={styles.statValue}>{data.tusebArastirmaci}</div>
          </div>
          <div className={styles.targetStatus}>
            <div className={styles.targetItem}>
              <span>Toplam:</span>
              <span className={data.tusebYurutucu + data.tusebArastirmaci >= TARGET.tusebYurutucu + TARGET.tusebArastirmaci ? styles.targetComplete : styles.targetIncomplete}>
                {data.tusebYurutucu + data.tusebArastirmaci} / {TARGET.tusebYurutucu + TARGET.tusebArastirmaci}
              </span>
            </div>
          </div>
        </div>

        <div className={styles.formSection}>
          <h4 className={styles.formTitle}>ADEP (Araştırma Üniversiteleri Destek Programı)</h4>
          <div className={styles.statRow}>
            <span className={styles.statLabel}>
              Yürütücü
              {completionStatus.adepYurutucu && <BsCheckCircle className={styles.targetComplete} />}
              <span className={styles.targetInfo}>(Hedef: {TARGET.adepYurutucu})</span>
            </span>
            <div className={styles.statValue}>{data.adepYurutucu}</div>
          </div>
          <div className={styles.statRow}>
            <span className={styles.statLabel}>
              Araştırmacı
              {completionStatus.adepArastirmaci && <BsCheckCircle className={styles.targetComplete} />}
              <span className={styles.targetInfo}>(Hedef: {TARGET.adepArastirmaci})</span>
            </span>
            <div className={styles.statValue}>{data.adepArastirmaci}</div>
          </div>
          <div className={styles.targetStatus}>
            <div className={styles.targetItem}>
              <span>Toplam:</span>
              <span className={data.adepYurutucu + data.adepArastirmaci >= TARGET.adepYurutucu + TARGET.adepArastirmaci ? styles.targetComplete : styles.targetIncomplete}>
                {data.adepYurutucu + data.adepArastirmaci} / {TARGET.adepYurutucu + TARGET.adepArastirmaci}
              </span>
            </div>
          </div>
        </div>

        <div className={styles.formSection}>
          <h4 className={styles.formTitle}>ÜNİV. SAN. İŞB. (58k)</h4>
          <div className={styles.statRow}>
            <span className={styles.statLabel}>
              Yürütücü
              {completionStatus.univSanIsbirligiYurutucu && <BsCheckCircle className={styles.targetComplete} />}
              <span className={styles.targetInfo}>(Hedef: {TARGET.univSanIsbirligiYurutucu})</span>
            </span>
            <div className={styles.statValue}>{data.univSanIsbirligiYurutucu}</div>
          </div>
          <div className={styles.statRow}>
            <span className={styles.statLabel}>
              Araştırmacı
              {completionStatus.univSanIsbirligiArastirmaci && <BsCheckCircle className={styles.targetComplete} />}
              <span className={styles.targetInfo}>(Hedef: {TARGET.univSanIsbirligiArastirmaci})</span>
            </span>
            <div className={styles.statValue}>{data.univSanIsbirligiArastirmaci}</div>
          </div>
          <div className={styles.targetStatus}>
            <div className={styles.targetItem}>
              <span>Toplam:</span>
              <span className={data.univSanIsbirligiYurutucu + data.univSanIsbirligiArastirmaci >= TARGET.univSanIsbirligiYurutucu + TARGET.univSanIsbirligiArastirmaci ? styles.targetComplete : styles.targetIncomplete}>
                {data.univSanIsbirligiYurutucu + data.univSanIsbirligiArastirmaci} / {TARGET.univSanIsbirligiYurutucu + TARGET.univSanIsbirligiArastirmaci}
              </span>
            </div>
          </div>
        </div>

        <div className={styles.formSection}>
          <h4 className={styles.formTitle}>KOSGEB Projeleri</h4>
          <div className={styles.statRow}>
            <span className={styles.statLabel}>
              Yürütücü
              {completionStatus.kosgebYurutucu && <BsCheckCircle className={styles.targetComplete} />}
              <span className={styles.targetInfo}>(Hedef: {TARGET.kosgebYurutucu})</span>
            </span>
            <div className={styles.statValue}>{data.kosgebYurutucu}</div>
          </div>
          <div className={styles.statRow}>
            <span className={styles.statLabel}>
              Araştırmacı
              {completionStatus.kosgebArastirmaci && <BsCheckCircle className={styles.targetComplete} />}
              <span className={styles.targetInfo}>(Hedef: {TARGET.kosgebArastirmaci})</span>
            </span>
            <div className={styles.statValue}>{data.kosgebArastirmaci}</div>
          </div>
        </div>

        <div className={styles.formSection}>
          <h4 className={styles.formTitle}>İSTKA Projeleri</h4>
          <div className={styles.statRow}>
            <span className={styles.statLabel}>
              Yürütücü
              {completionStatus.istkaYurutucu && <BsCheckCircle className={styles.targetComplete} />}
              <span className={styles.targetInfo}>(Hedef: {TARGET.istkaYurutucu})</span>
            </span>
            <div className={styles.statValue}>{data.istkaYurutucu}</div>
          </div>
          <div className={styles.statRow}>
            <span className={styles.statLabel}>
              Araştırmacı
              {completionStatus.istkaArastirmaci && <BsCheckCircle className={styles.targetComplete} />}
              <span className={styles.targetInfo}>(Hedef: {TARGET.istkaArastirmaci})</span>
            </span>
            <div className={styles.statValue}>{data.istkaArastirmaci}</div>
          </div>
        </div>

        <div className={styles.formSection}>
          <h4 className={styles.formTitle}>BAP Projeleri</h4>
          <p className={styles.detailsLabel}>
            2025 yılı içerisinde Bilimsel Araştırma Projeleri (BAP) kapsamında yürütülmesi planlanan projelerin sayısını belirtiniz.
          </p>
          <div className={styles.statRow}>
            <span className={styles.statLabel}>
              Yürütücü
              {completionStatus.bapYurutucu && <BsCheckCircle className={styles.targetComplete} />}
              <span className={styles.targetInfo}>(Hedef: {TARGET.bapYurutucu})</span>
            </span>
            <div className={styles.statValue}>{data.bapYurutucu}</div>
          </div>
          <div className={styles.statRow}>
            <span className={styles.statLabel}>
              Araştırmacı
              {completionStatus.bapArastirmaci && <BsCheckCircle className={styles.targetComplete} />}
              <span className={styles.targetInfo}>(Hedef: {TARGET.bapArastirmaci})</span>
            </span>
            <div className={styles.statValue}>{data.bapArastirmaci}</div>
          </div>
          <div className={styles.targetStatus}>
            <div className={styles.targetItem}>
              <span>Toplam:</span>
              <span className={data.bapYurutucu + data.bapArastirmaci >= TARGET.bapYurutucu + TARGET.bapArastirmaci ? styles.targetComplete : styles.targetIncomplete}>
                {data.bapYurutucu + data.bapArastirmaci} / {TARGET.bapYurutucu + TARGET.bapArastirmaci}
              </span>
            </div>
          </div>
        </div>
      </div>

      <div className={styles.totalSection}>
        <div className={styles.totalRow}>
          <span>Toplam Horizon Europe</span>
          <div>{totalHorizon} / {targetHorizon}</div>
        </div>
        <div className={styles.totalRow}>
          <span>Toplam Horizon Ortaklık</span>
          <div>{totalHorizonOrtaklik} / {targetHorizonOrtaklik}</div>
        </div>
        <div className={styles.totalRow}>
          <span>Toplam TÜBİTAK İkili İşbirliği</span>
          <div>{totalTubitakIkiliIsbirligi} / {targetTubitakIkiliIsbirligi}</div>
        </div>
        <div className={styles.totalRow}>
          <span>Toplam TÜBİTAK</span>
          <div>{totalTubitak} / {targetTubitak}</div>
        </div>
        <div className={styles.totalRow}>
          <span>Toplam ERASMUS+</span>
          <div>{totalErasmus} / {targetErasmus}</div>
        </div>
        <div className={styles.totalRow}>
          <span>Toplam Diğer AB</span>
          <div>{totalDigerAb} / {targetDigerAb}</div>
        </div>
        <div className={styles.totalRow}>
          <span>Toplam TÜSEB</span>
          <div>{totalTuseb} / {targetTuseb}</div>
        </div>
        <div className={styles.totalRow}>
          <span>Toplam ADEP</span>
          <div>{totalAdep} / {targetAdep}</div>
        </div>
        <div className={styles.totalRow}>
          <span>Toplam ÜNİV. SAN. İŞB.</span>
          <div>{totalUnivSanIsbirligi} / {targetUnivSanIsbirligi}</div>
        </div>
        <div className={styles.totalRow}>
          <span>Toplam KOSGEB</span>
          <div>{totalKosgeb} / {targetKosgeb}</div>
        </div>
        <div className={styles.totalRow}>
          <span>Toplam BAP</span>
          <div>{totalBap} / {targetBap}</div>
        </div>
        <div className={styles.totalRow}>
          <span>Toplam İSTKA</span>
          <div>{totalIstka} / {targetIstka}</div>
        </div>
        <div className={styles.totalRow} style={{ marginTop: '12px', fontWeight: 'bold' }}>
          <span>Toplam Proje</span>
          <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
            {totalProjects} / {targetTotal}
            <span className={totalProjects >= targetTotal ? styles.trendUp : styles.trendDown}>
              {totalProjects >= targetTotal ? <BsArrowUp /> : <BsArrowDown />}
              {Math.abs(targetTotal - totalProjects)}
            </span>
          </div>
        </div>

        <div className={styles.progressBar}>
          <div 
            className={styles.progressFill} 
            style={{ width: `${(totalProjects / targetTotal) * 100}%` }} 
          />
          <span className={styles.progressLabel}>
            {`${((totalProjects / targetTotal) * 100).toFixed(1)}% (Hedef: ${targetTotal})`}
          </span>
        </div>
      </div>

      {showEditModal && (
        <div className={styles.modalOverlay}>
          <div className={styles.modal} data-type="projeler">
            <div className={styles.modalHeader}>
              <h2 className={styles.modalTitle}>
                <BsClipboardData /> Proje Hedeflerini Düzenle
              </h2>
              <button 
                className={styles.actionButton}
                onClick={() => setShowEditModal(false)}
                aria-label="Kapat"
              >
                <BsX size={24} />
              </button>
            </div>
            
            <form className={styles.modalForm}>
              <div className={styles.formSection}>
                <h3 className={styles.formTitle}>Horizon Europe Projeleri</h3>
                <p className={styles.detailsLabel}>
                  2025 yılı içerisinde Horizon Europe kapsamında Yürütücü ve Araştırmacı olduğunuz proje sayısını giriniz.
                </p>
                <div className={styles.formRow}>
                  <div className={styles.formGroup}>
                    <label className={styles.formLabel}>Yürütücü (Hedef: {TARGET.horizonEuropeYurutucu})</label>
                    <input 
                      type="number" 
                      className={styles.formInput}
                      value={data.horizonEuropeYurutucu}
                      min="0"
                    />
                  </div>
                  <div className={styles.formGroup}>
                    <label className={styles.formLabel}>Araştırmacı (Hedef: {TARGET.horizonEuropeArastirmaci})</label>
                    <input 
                      type="number" 
                      className={styles.formInput}
                      value={data.horizonEuropeArastirmaci}
                      min="0"
                    />
                  </div>
                </div>
              </div>

              <div className={styles.formSection}>
                <h3 className={styles.formTitle}>HORIZON EUROPE ORTAKLIK PROJELERİ</h3>
                <p className={styles.detailsLabel}>
                  2025 yılı içerisinde ERA PerMed, PRIMA, IHI vb. kapsamında yürütülmesi planlanan projelerin sayısını belirtiniz.
                </p>
                <div className={styles.formRow}>
                  <div className={styles.formGroup}>
                    <label className={styles.formLabel}>Yürütücü (Hedef: {TARGET.horizonOrtaklikYurutucu})</label>
                    <input 
                      type="number" 
                      className={styles.formInput}
                      value={data.horizonOrtaklikYurutucu}
                      min="0"
                    />
                  </div>
                  <div className={styles.formGroup}>
                    <label className={styles.formLabel}>Araştırmacı (Hedef: {TARGET.horizonOrtaklikArastirmaci})</label>
                    <input 
                      type="number" 
                      className={styles.formInput}
                      value={data.horizonOrtaklikArastirmaci}
                      min="0"
                    />
                  </div>
                </div>
              </div>

              <div className={styles.formSection}>
                <h3 className={styles.formTitle}>TÜBİTAK İKİLİ İŞBİRLİĞİ (1071)</h3>
                <p className={styles.detailsLabel}>
                  2025 yılı içerisinde TÜBİTAK İkili İşbirliği kapsamında yürütülmesi planlanan projelerin sayısını belirtiniz.
                </p>
                <div className={styles.formRow}>
                  <div className={styles.formGroup}>
                    <label className={styles.formLabel}>Yürütücü (Hedef: {TARGET.tubitakIkiliIsbirligiYurutucu})</label>
                    <input 
                      type="number" 
                      className={styles.formInput}
                      value={data.tubitakIkiliIsbirligiYurutucu}
                      min="0"
                    />
                  </div>
                  <div className={styles.formGroup}>
                    <label className={styles.formLabel}>Araştırmacı (Hedef: {TARGET.tubitakIkiliIsbirligiArastirmaci})</label>
                    <input 
                      type="number" 
                      className={styles.formInput}
                      value={data.tubitakIkiliIsbirligiArastirmaci}
                      min="0"
                    />
                  </div>
                </div>
              </div>

              <div className={styles.formSection}>
                <h3 className={styles.formTitle}>TÜBİTAK Projeleri</h3>
                <p className={styles.detailsLabel}>
                  2025 yılı içerisinde TÜBİTAK programı kapsamında yürütülmesi planlanan projelerin sayısını ilgili programa göre belirtiniz.
                </p>
                <div className={styles.formRow}>
                  <div className={styles.formGroup}>
                    <label className={styles.formLabel}>TÜBİTAK 1001 Yürütücü (Hedef: {TARGET.tubitak1001Yurutucu})</label>
                    <input 
                      type="number" 
                      className={styles.formInput}
                      value={data.tubitak1001Yurutucu}
                      min="0"
                    />
                  </div>
                  <div className={styles.formGroup}>
                    <label className={styles.formLabel}>TÜBİTAK 1001 Araştırmacı (Hedef: {TARGET.tubitak1001Arastirmaci})</label>
                    <input 
                      type="number" 
                      className={styles.formInput}
                      value={data.tubitak1001Arastirmaci}
                      min="0"
                    />
                  </div>
                </div>

                <div className={styles.formRow}>
                  <div className={styles.formGroup}>
                    <label className={styles.formLabel}>TÜBİTAK 1002 Yürütücü (Hedef: {TARGET.tubitak1002Yurutucu})</label>
                    <input 
                      type="number" 
                      className={styles.formInput}
                      value={data.tubitak1002Yurutucu}
                      min="0"
                    />
                  </div>
                  <div className={styles.formGroup}>
                    <label className={styles.formLabel}>TÜBİTAK 1002 Araştırmacı (Hedef: {TARGET.tubitak1002Arastirmaci})</label>
                    <input 
                      type="number" 
                      className={styles.formInput}
                      value={data.tubitak1002Arastirmaci}
                      min="0"
                    />
                  </div>
                </div>

                <div className={styles.formRow}>
                  <div className={styles.formGroup}>
                    <label className={styles.formLabel}>TÜBİTAK 1003 Yürütücü (Hedef: {TARGET.tubitak1003Yurutucu})</label>
                    <input 
                      type="number" 
                      className={styles.formInput}
                      value={data.tubitak1003Yurutucu}
                      min="0"
                    />
                  </div>
                  <div className={styles.formGroup}>
                    <label className={styles.formLabel}>TÜBİTAK 1003 Araştırmacı (Hedef: {TARGET.tubitak1003Arastirmaci})</label>
                    <input 
                      type="number" 
                      className={styles.formInput}
                      value={data.tubitak1003Arastirmaci}
                      min="0"
                    />
                  </div>
                </div>

                <div className={styles.formRow}>
                  <div className={styles.formGroup}>
                    <label className={styles.formLabel}>TÜBİTAK 1004 Yürütücü (Hedef: {TARGET.tubitak1004Yurutucu})</label>
                    <input 
                      type="number" 
                      className={styles.formInput}
                      value={data.tubitak1004Yurutucu}
                      min="0"
                    />
                  </div>
                  <div className={styles.formGroup}>
                    <label className={styles.formLabel}>TÜBİTAK 1004 Araştırmacı (Hedef: {TARGET.tubitak1004Arastirmaci})</label>
                    <input 
                      type="number" 
                      className={styles.formInput}
                      value={data.tubitak1004Arastirmaci}
                      min="0"
                    />
                  </div>
                </div>

                <div className={styles.formRow}>
                  <div className={styles.formGroup}>
                    <label className={styles.formLabel}>TÜBİTAK 1005 Yürütücü (Hedef: {TARGET.tubitak1005Yurutucu})</label>
                    <input 
                      type="number" 
                      className={styles.formInput}
                      value={data.tubitak1005Yurutucu}
                      min="0"
                    />
                  </div>
                  <div className={styles.formGroup}>
                    <label className={styles.formLabel}>TÜBİTAK 1005 Araştırmacı (Hedef: {TARGET.tubitak1005Arastirmaci})</label>
                    <input 
                      type="number" 
                      className={styles.formInput}
                      value={data.tubitak1005Arastirmaci}
                      min="0"
                    />
                  </div>
                </div>

                <div className={styles.formRow}>
                  <div className={styles.formGroup}>
                    <label className={styles.formLabel}>TÜBİTAK 1505 Yürütücü (Hedef: {TARGET.tubitak1505Yurutucu})</label>
                    <input 
                      type="number" 
                      className={styles.formInput}
                      value={data.tubitak1505Yurutucu}
                      min="0"
                    />
                  </div>
                  <div className={styles.formGroup}>
                    <label className={styles.formLabel}>TÜBİTAK 1505 Araştırmacı (Hedef: {TARGET.tubitak1505Arastirmaci})</label>
                    <input 
                      type="number" 
                      className={styles.formInput}
                      value={data.tubitak1505Arastirmaci}
                      min="0"
                    />
                  </div>
                </div>

                <div className={styles.formRow}>
                  <div className={styles.formGroup}>
                    <label className={styles.formLabel}>TÜBİTAK 2209 Yürütücü (Hedef: {TARGET.tubitak2209Yurutucu})</label>
                    <input 
                      type="number" 
                      className={styles.formInput}
                      value={data.tubitak2209Yurutucu}
                      min="0"
                    />
                  </div>
                  <div className={styles.formGroup}>
                    <label className={styles.formLabel}>TÜBİTAK 2209 Araştırmacı (Hedef: {TARGET.tubitak2209Arastirmaci})</label>
                    <input 
                      type="number" 
                      className={styles.formInput}
                      value={data.tubitak2209Arastirmaci}
                      min="0"
                    />
                  </div>
                </div>

                <div className={styles.formRow}>
                  <div className={styles.formGroup}>
                    <label className={styles.formLabel}>TÜBİTAK 3005 Yürütücü (Hedef: {TARGET.tubitak3005Yurutucu})</label>
                    <input 
                      type="number" 
                      className={styles.formInput}
                      value={data.tubitak3005Yurutucu}
                      min="0"
                    />
                  </div>
                  <div className={styles.formGroup}>
                    <label className={styles.formLabel}>TÜBİTAK 3005 Araştırmacı (Hedef: {TARGET.tubitak3005Arastirmaci})</label>
                    <input 
                      type="number" 
                      className={styles.formInput}
                      value={data.tubitak3005Arastirmaci}
                      min="0"
                    />
                  </div>
                </div>

                <div className={styles.formRow}>
                  <div className={styles.formGroup}>
                    <label className={styles.formLabel}>TÜBİTAK 3501 Yürütücü (Hedef: {TARGET.tubitak3501Yurutucu})</label>
                    <input 
                      type="number" 
                      className={styles.formInput}
                      value={data.tubitak3501Yurutucu}
                      min="0"
                    />
                  </div>
                  <div className={styles.formGroup}>
                    <label className={styles.formLabel}>TÜBİTAK 3501 Araştırmacı (Hedef: {TARGET.tubitak3501Arastirmaci})</label>
                    <input 
                      type="number" 
                      className={styles.formInput}
                      value={data.tubitak3501Arastirmaci}
                      min="0"
                    />
                  </div>
                </div>
              </div>

              <div className={styles.formSection}>
                <h3 className={styles.formTitle}>ERASMUS+ Projeleri</h3>
                <p className={styles.detailsLabel}>
                  2025 yılı içerisinde ERASMUS+ kapsamında yürütülmesi planlanan projelerin sayısını belirtiniz.
                </p>
                <div className={styles.formRow}>
                  <div className={styles.formGroup}>
                    <label className={styles.formLabel}>Yürütücü (Hedef: {TARGET.erasmusYurutucu})</label>
                    <input 
                      type="number" 
                      className={styles.formInput}
                      value={data.erasmusYurutucu}
                      min="0"
                    />
                  </div>
                  <div className={styles.formGroup}>
                    <label className={styles.formLabel}>Araştırmacı (Hedef: {TARGET.erasmusArastirmaci})</label>
                    <input 
                      type="number" 
                      className={styles.formInput}
                      value={data.erasmusArastirmaci}
                      min="0"
                    />
                  </div>
                </div>
              </div>

              <div className={styles.formSection}>
                <h3 className={styles.formTitle}>Diğer AB Projeleri</h3>
                <p className={styles.detailsLabel}>
                  2025 yılı içerisinde UNICEF, UNDP, NVIDIA vb. kapsamında yürütülmesi planlanan projelerin sayısını belirtiniz.
                </p>
                <div className={styles.formRow}>
                  <div className={styles.formGroup}>
                    <label className={styles.formLabel}>Yürütücü (Hedef: {TARGET.digerAbYurutucu})</label>
                    <input 
                      type="number" 
                      className={styles.formInput}
                      value={data.digerAbYurutucu}
                      min="0"
                    />
                  </div>
                  <div className={styles.formGroup}>
                    <label className={styles.formLabel}>Araştırmacı (Hedef: {TARGET.digerAbArastirmaci})</label>
                    <input 
                      type="number" 
                      className={styles.formInput}
                      value={data.digerAbArastirmaci}
                      min="0"
                    />
                  </div>
                </div>
              </div>

              <div className={styles.formSection}>
                <h3 className={styles.formTitle}>TÜSEB Projeleri</h3>
                <p className={styles.detailsLabel}>
                  2025 yılı içerisinde TÜSEB kapsamında yürütülmesi planlanan projelerin sayısını belirtiniz.
                </p>
                <div className={styles.formRow}>
                  <div className={styles.formGroup}>
                    <label className={styles.formLabel}>Yürütücü (Hedef: {TARGET.tusebYurutucu})</label>
                    <input 
                      type="number" 
                      className={styles.formInput}
                      value={data.tusebYurutucu}
                      min="0"
                    />
                  </div>
                  <div className={styles.formGroup}>
                    <label className={styles.formLabel}>Araştırmacı (Hedef: {TARGET.tusebArastirmaci})</label>
                    <input 
                      type="number" 
                      className={styles.formInput}
                      value={data.tusebArastirmaci}
                      min="0"
                    />
                  </div>
                </div>
              </div>

              <div className={styles.formSection}>
                <h3 className={styles.formTitle}>KOSGEB Projeleri</h3>
                <p className={styles.detailsLabel}>
                  2025 yılı içerisinde KOSGEB kapsamında yürütülmesi planlanan projelerin sayısını belirtiniz.
                </p>
                <div className={styles.formRow}>
                  <div className={styles.formGroup}>
                    <label className={styles.formLabel}>Yürütücü (Hedef: {TARGET.kosgebYurutucu})</label>
                    <input 
                      type="number" 
                      className={styles.formInput}
                      value={data.kosgebYurutucu}
                      min="0"
                    />
                  </div>
                  <div className={styles.formGroup}>
                    <label className={styles.formLabel}>Araştırmacı (Hedef: {TARGET.kosgebArastirmaci})</label>
                    <input 
                      type="number" 
                      className={styles.formInput}
                      value={data.kosgebArastirmaci}
                      min="0"
                    />
                  </div>
                </div>
              </div>

              <div className={styles.formSection}>
                <h3 className={styles.formTitle}>İSTKA Projeleri</h3>
                <p className={styles.detailsLabel}>
                  2025 yılı içerisinde İSTKA kapsamında yürütülmesi planlanan projelerin sayısını belirtiniz.
                </p>
                <div className={styles.formRow}>
                  <div className={styles.formGroup}>
                    <label className={styles.formLabel}>Yürütücü (Hedef: {TARGET.istkaYurutucu})</label>
                    <input 
                      type="number" 
                      className={styles.formInput}
                      value={data.istkaYurutucu}
                      min="0"
                    />
                  </div>
                  <div className={styles.formGroup}>
                    <label className={styles.formLabel}>Araştırmacı (Hedef: {TARGET.istkaArastirmaci})</label>
                    <input 
                      type="number" 
                      className={styles.formInput}
                      value={data.istkaArastirmaci}
                      min="0"
                    />
                  </div>
                </div>
              </div>

              <div className={styles.formSection}>
                <h3 className={styles.formTitle}>BAP Projeleri</h3>
                <p className={styles.detailsLabel}>
                  2025 yılı içerisinde Bilimsel Araştırma Projeleri (BAP) kapsamında yürütülmesi planlanan projelerin sayısını belirtiniz.
                </p>
                <div className={styles.formRow}>
                  <div className={styles.formGroup}>
                    <label className={styles.formLabel}>Yürütücü (Hedef: {TARGET.bapYurutucu})</label>
                    <input 
                      type="number" 
                      className={styles.formInput}
                      value={data.bapYurutucu}
                      min="0"
                    />
                  </div>
                  <div className={styles.formGroup}>
                    <label className={styles.formLabel}>Araştırmacı (Hedef: {TARGET.bapArastirmaci})</label>
                    <input 
                      type="number" 
                      className={styles.formInput}
                      value={data.bapArastirmaci}
                      min="0"
                    />
                  </div>
                </div>
              </div>

              <div className={styles.formSection}>
                <h3 className={styles.formTitle}>ADEP Projeleri</h3>
                <p className={styles.detailsLabel}>
                  2025 yılı içerisinde ADEP kapsamında yürütülmesi planlanan projelerin sayısını belirtiniz.
                </p>
                <div className={styles.formRow}>
                  <div className={styles.formGroup}>
                    <label className={styles.formLabel}>Yürütücü (Hedef: {TARGET.adepYurutucu})</label>
                    <input 
                      type="number" 
                      className={styles.formInput}
                      value={data.adepYurutucu}
                      min="0"
                    />
                  </div>
                  <div className={styles.formGroup}>
                    <label className={styles.formLabel}>Araştırmacı (Hedef: {TARGET.adepArastirmaci})</label>
                    <input 
                      type="number" 
                      className={styles.formInput}
                      value={data.adepArastirmaci}
                      min="0"
                    />
                  </div>
                </div>
              </div>

              <div className={styles.formSection}>
                <h3 className={styles.formTitle}>ÜNİV. SAN. İŞB. (58k)</h3>
                <p className={styles.detailsLabel}>
                  2025 yılı içerisinde ÜNİV. SAN. İŞB. kapsamında yürütülmesi planlanan projelerin sayısını belirtiniz.
                </p>
                <div className={styles.formRow}>
                  <div className={styles.formGroup}>
                    <label className={styles.formLabel}>Yürütücü (Hedef: {TARGET.univSanIsbirligiYurutucu})</label>
                    <input 
                      type="number" 
                      className={styles.formInput}
                      value={data.univSanIsbirligiYurutucu}
                      min="0"
                    />
                  </div>
                  <div className={styles.formGroup}>
                    <label className={styles.formLabel}>Araştırmacı (Hedef: {TARGET.univSanIsbirligiArastirmaci})</label>
                    <input 
                      type="number" 
                      className={styles.formInput}
                      value={data.univSanIsbirligiArastirmaci}
                      min="0"
                    />
                  </div>
                </div>
              </div>

            </form>

            <div className={styles.buttonContainer}>
              <button 
                className={styles.cancelButton}
                onClick={() => setShowEditModal(false)}
              >
                İptal
              </button>
              <button className={styles.saveButton}>
                Kaydet
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ProjelerCard; 